export default (totalItems, itemPerPages, currentPage) => {
    //var numberOfPages = Math.floor((totalItems + itemPerPages - 1) / itemPerPages);
    var start = (currentPage * itemPerPages) - (itemPerPages - 1);
    var end = Math.min(start + itemPerPages - 1, totalItems);

    return 'Showing ' + start + ' to ' + end + ' of ' + totalItems + ' entries' 
};